import React from 'react';
import './src/styles/global.css';
import RootElement from './src/components/root';

export const onClientEntry = () => {
  if (process.env.GATSBY_MSW_ENABLED !== "true") {
    return;
  }

  return import("./src/mocks/browser").then(({ worker }) => {
    return worker.start({
      onUnhandledRequest: "bypass",
      serviceWorker: {
        url: "/mockServiceWorker.js",
      },
    });
  });
};

export const wrapPageElement = ({ element }: any) => {
  return <RootElement>{element}</RootElement>;
}
